import React from 'react'

import Block from 'app/components/common/block/block.component'
import ErrorComponent from 'app/components/errors/error.component'

import 'app/pages/errors/error-page.scss'

const NotFoundPage = () => (
  <Block type="main" className="error-page">
    <ErrorComponent
      title="Page not found"
      message="Sorry, the page you are looking for is not found"
      button
    />
  </Block>
)

export default NotFoundPage
